import classNames from 'classnames';
import { type MouseEventHandler } from 'react';
import Styles from './Button.module.scss';

interface ButtonProps {
    onClick: MouseEventHandler<HTMLButtonElement>;
    children?: string | string[] | React.ReactElement;
    mediumGreen?: boolean;
    full?: boolean;
    silent?: boolean;
    small?: boolean;
    smallPadding?: boolean;
    onDark?: boolean;
    red?: boolean;
    title?: string;
    disabled?: boolean;
}

function Button(props: Readonly<ButtonProps>): React.ReactElement {
    const { onClick, children, mediumGreen, full, silent, small, smallPadding, onDark, red, title, disabled } = props;

    const classes = classNames(Styles.button, {
        [Styles.mediumGreen]: mediumGreen,
        [Styles.full]: full,
        [Styles.silent]: silent,
        [Styles.small]: small,
        [Styles.smallPadding]: smallPadding,
        [Styles.onDark]: onDark,
        [Styles.red]: red,
    });

    const handleOnClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        if (disabled) {
            return;
        }

        onClick(event);
    };

    return (
        <button
            className={classes}
            onClick={handleOnClick}
            title={title}
            disabled={disabled}
        >
            {children}
        </button>
    );
}

export default Button;
